import React from "react";
import { motion } from "framer-motion";
import banner from "../banner1.webp";
import StatsSection from "./StatsSection";

export default function HeroBanner() {
  return (
    <section
      id="home"
      className="relative h-[620px] bg-cover bg-left backdrop-blur-md"
      style={{ backgroundImage: "url('/banner-home.jpeg')" }}
    >
      {/* Overlay Glow */}
      <div className="absolute inset-0 bg-black/80"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* LEFT CONTENT */}
          <div className="text-center lg:text-left pt-10">
            <div class="hero-eyebrow">
              Capital · Debt · Equity · Structured Finance
            </div>

            {/* Heading */}
            <h1 className="text-2xl sm:text-3xl lg:text-6xl font-extralight text-white leading-tight mb-4 sm:mb-6 max-w-[500px]">
              Capital structured for{" "}
              <span className="text-[var(--ms-premium-gold)]">
                every layer{" "}
              </span>
              of your ambition
            </h1>

            {/* Description */}
            <p className="text-sm sm:text-md md:text-lg text-white/60 mb-8 leading-relaxed pt-3 font-light">
              Y&B Capital connects businesses across India with the right
              capital - from senior debt and mezzanine financing to equity,
              government schemes, and international markets.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start pt-5">
              <button className="bg-dark-gold text-white uppercase px-6 py-3  font-medium hover:scale-105 transition">
                Discuss a Transaction
              </button>

              <button className=" outline co text-white uppercase px-6 py-3 font-medium hover:scale-105 transition">
                Our Solutions
              </button>
            </div>
          </div>
          {/* right */}
          <div className="capital-stack">
            <div className="stack-label">
              The Capital Stack — Your Full Spectrum
            </div>
            <div className="stack-bar tier-equity">
              <span className="stack-bar-label">Equity & Private Capital</span>
              <span className="stack-bar-tag">Angel · VC · PE · Pre-IPO</span>
            </div>
            <div className="stack-bar tier-mez">
              <span className="stack-bar-label">Hybrid & Mezzanine</span>
              <span className="stack-bar-tag">CCDs · OCDs · Quasi-Equity</span>
            </div>
            <div className="stack-bar tier-sub text-white/90">
              <span className="stack-bar-label">
                Alternative & Private Credit
              </span>
              <span className="stack-bar-tag">Venture Debt · Rescue · RBF</span>
            </div>
            <div className="stack-bar tier-senior text-white/70">
              <span className="stack-bar-label">
                Senior Debt · NBFCs · Banks
              </span>
              <span className="stack-bar-tag">
                Working Capital · Term · Trade
              </span>
            </div>
            <div className="stack-bar tier-govt text-white/50">
              <span className="stack-bar-label">Government & DFI Schemes</span>
              <span className="stack-bar-tag">CGTMSE · SIDBI · NABARD</span>
            </div>
          </div>
        </div>
        {/* <StatsSection /> */}
        {/* <CustomerList/> */}
      </div>
    </section>
  );
}
